/**
 * Every SBC formation's eleven slots, by EA's formation id (`f433`, ...), in
 * the order the solver returns its players. The one source for both apps' pitch
 * views: they share this rather than each keeping a copy, which is how mobile
 * once crashed on a formation only web knew.
 */
export const FORMATION_POSITIONS = {
    f3142: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "79%", top: "67%", wideTop: "68.65%" },
        { left: "50%", top: "62%", wideTop: "63.9%" },
        { left: "21%", top: "67%", wideTop: "68.65%" },
        { left: "50%", top: "40%", wideTop: "43%" },
        { left: "90%", top: "36%", wideTop: "39.2%" },
        { left: "69%", top: "37%", wideTop: "40.15%" },
        { left: "31%", top: "37%", wideTop: "40.15%" },
        { left: "10%", top: "36%", wideTop: "39.2%" },
        { left: "70%", top: "14.5%", wideTop: "18.775%" },
        { left: "30%", top: "14.5%", wideTop: "18.775%" },
    ],
    f3412: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "79%", top: "67%", wideTop: "68.65%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "21%", top: "67%", wideTop: "68.65%" },
        { left: "90%", top: "43%", wideTop: "45.85%" },
        { left: "68.5%", top: "44.5%", wideTop: "47.275%" },
        { left: "31.5%", top: "44.5%", wideTop: "47.275%" },
        { left: "10%", top: "43%", wideTop: "45.85%" },
        { left: "50%", top: "28%", wideTop: "31.6%" },
        { left: "70%", top: "17%", wideTop: "21.15%" },
        { left: "30%", top: "17%", wideTop: "21.15%" },
    ],
    f3421: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "79%", top: "67%", wideTop: "68.65%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "21%", top: "67%", wideTop: "68.65%" },
        { left: "90%", top: "44%", wideTop: "46.8%" },
        { left: "67.5%", top: "45%", wideTop: "47.75%" },
        { left: "32.5%", top: "45%", wideTop: "47.75%" },
        { left: "10%", top: "44%", wideTop: "46.8%" },
        { left: "70.5%", top: "20.5%", wideTop: "24.475%" },
        { left: "29.5%", top: "20.5%", wideTop: "24.475%" },
        { left: "50%", top: "15%", wideTop: "19.25%" },
    ],
    f343: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "77%", top: "66%", wideTop: "67.7%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "23%", top: "66%", wideTop: "67.7%" },
        { left: "90%", top: "39%", wideTop: "42.05%" },
        { left: "68%", top: "43.5%", wideTop: "46.325%" },
        { left: "32%", top: "43.5%", wideTop: "46.325%" },
        { left: "10%", top: "39%", wideTop: "42.05%" },
        { left: "72%", top: "18%", wideTop: "22.1%" },
        { left: "50%", top: "16%", wideTop: "20.2%" },
        { left: "28%", top: "18%", wideTop: "22.1%" },
    ],
    f352: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "78%", top: "66%", wideTop: "67.7%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "22%", top: "66%", wideTop: "67.7%" },
        { left: "69%", top: "43%", wideTop: "45.85%" },
        { left: "31%", top: "43%", wideTop: "45.85%" },
        { left: "90%", top: "36%", wideTop: "39.2%" },
        { left: "10%", top: "36%", wideTop: "39.2%" },
        { left: "50%", top: "28%", wideTop: "31.6%" },
        { left: "70%", top: "14%", wideTop: "18.3%" },
        { left: "30%", top: "14%", wideTop: "18.3%" },
    ],
    f41212: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "68%", top: "66%", wideTop: "67.7%" },
        { left: "32%", top: "66%", wideTop: "67.7%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "50%", top: "48%", wideTop: "50.6%" },
        { left: "78%", top: "40%", wideTop: "43%" },
        { left: "22%", top: "40%", wideTop: "43%" },
        { left: "50%", top: "25%", wideTop: "28.75%" },
        { left: "70%", top: "16%", wideTop: "20.2%" },
        { left: "30%", top: "16%", wideTop: "20.2%" },
    ],
    f41212a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "88%", top: "64%", wideTop: "65.8%" },
        { left: "68%", top: "69%", wideTop: "70.55%" },
        { left: "32%", top: "69%", wideTop: "70.55%" },
        { left: "12%", top: "64%", wideTop: "65.8%" },
        { left: "50%", top: "47%", wideTop: "49.65%" },
        { left: "80%", top: "40%", wideTop: "43%" },
        { left: "20%", top: "40%", wideTop: "43%" },
        { left: "50%", top: "24%", wideTop: "27.8%" },
        { left: "70%", top: "14%", wideTop: "18.3%" },
        { left: "30%", top: "14%", wideTop: "18.3%" },
    ],
    f4132: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "65%", wideTop: "66.75%" },
        { left: "70%", top: "68%", wideTop: "69.6%" },
        { left: "30%", top: "68%", wideTop: "69.6%" },
        { left: "10%", top: "65%", wideTop: "66.75%" },
        { left: "50%", top: "58%", wideTop: "60.1%" },
        { left: "78%", top: "36%", wideTop: "39.2%" },
        { left: "50%", top: "36%", wideTop: "39.2%" },
        { left: "22%", top: "36%", wideTop: "39.2%" },
        { left: "63%", top: "15%", wideTop: "19.25%" },
        { left: "37%", top: "15%", wideTop: "19.25%" },
    ],
    f4141: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "63%", wideTop: "64.85%" },
        { left: "70%", top: "66%", wideTop: "67.7%" },
        { left: "30%", top: "66%", wideTop: "67.7%" },
        { left: "10%", top: "63%", wideTop: "64.85%" },
        { left: "50%", top: "47%", wideTop: "49.65%" },
        { left: "89%", top: "34.5%", wideTop: "37.775%" },
        { left: "70%", top: "36%", wideTop: "39.2%" },
        { left: "30%", top: "36%", wideTop: "39.2%" },
        { left: "11%", top: "34.5%", wideTop: "37.775%" },
        { left: "50%", top: "15%", wideTop: "19.25%" },
    ],
    f4213: [
        { left: "50%", top: "80%", wideTop: "84%" },
        { left: "90%", top: "61%", wideTop: "62%" },
        { left: "68%", top: "69%", wideTop: "70%" },
        { left: "32%", top: "69%", wideTop: "70%" },
        { left: "10%", top: "61%", wideTop: "62%" },
        { left: "72%", top: "46%", wideTop: "47%" },
        { left: "28%", top: "46%", wideTop: "47%" },
        { left: "50%", top: "36%", wideTop: "37%" },
        { left: "85%", top: "20%", wideTop: "21%" },
        { left: "50%", top: "14%", wideTop: "16%" },
        { left: "15%", top: "20%", wideTop: "21%" },
    ],
    f4222: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "70%", top: "66%", wideTop: "67.7%" },
        { left: "30%", top: "66%", wideTop: "67.7%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "65%", top: "42%", wideTop: "44.9%" },
        { left: "35%", top: "42%", wideTop: "44.9%" },
        { left: "87%", top: "35%", wideTop: "38.25%" },
        { left: "13%", top: "35%", wideTop: "38.25%" },
        { left: "62%", top: "15%", wideTop: "19.25%" },
        { left: "38%", top: "15%", wideTop: "19.25%" },
    ],
    f4231: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "69%", wideTop: "70.55%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "10%", top: "69%", wideTop: "70.55%" },
        { left: "80%", top: "47%", wideTop: "49.65%" },
        { left: "20%", top: "47%", wideTop: "49.65%" },
        { left: "70%", top: "25%", wideTop: "28.75%" },
        { left: "50%", top: "37.5%", wideTop: "40.625%" },
        { left: "30%", top: "25%", wideTop: "28.75%" },
        { left: "50%", top: "13.5%", wideTop: "17.825%" },
    ],
    f4231a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "70%", wideTop: "71.5%" },
        { left: "69%", top: "72%", wideTop: "73.4%" },
        { left: "31%", top: "72%", wideTop: "73.4%" },
        { left: "10%", top: "70%", wideTop: "71.5%" },
        { left: "71%", top: "50%", wideTop: "52.5%" },
        { left: "29%", top: "50%", wideTop: "52.5%" },
        { left: "90%", top: "33.5%", wideTop: "36.825%" },
        { left: "10%", top: "33.5%", wideTop: "36.825%" },
        { left: "50%", top: "37.5%", wideTop: "40.625%" },
        { left: "50%", top: "13.5%", wideTop: "17.825%" },
    ],
    f424: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "65%", wideTop: "66.75%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "10%", top: "65%", wideTop: "66.75%" },
        { left: "68%", top: "47%", wideTop: "49.65%" },
        { left: "32%", top: "47%", wideTop: "49.65%" },
        { left: "89%", top: "32.5%", wideTop: "35.875%" },
        { left: "68%", top: "15%", wideTop: "19.25%" },
        { left: "32%", top: "15%", wideTop: "19.25%" },
        { left: "11%", top: "32.5%", wideTop: "35.875%" },
    ],
    f4312: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "69%", top: "66%", wideTop: "67.7%" },
        { left: "31%", top: "66%", wideTop: "67.7%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "82%", top: "36%", wideTop: "39.2%" },
        { left: "50%", top: "46%", wideTop: "48.7%" },
        { left: "18%", top: "36%", wideTop: "39.2%" },
        { left: "50%", top: "22%", wideTop: "25.9%" },
        { left: "70%", top: "13%", wideTop: "17.35%" },
        { left: "30%", top: "13%", wideTop: "17.35%" },
    ],
    f4321: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "68%", top: "67%", wideTop: "68.65%" },
        { left: "32%", top: "67%", wideTop: "68.65%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "80%", top: "40%", wideTop: "43%" },
        { left: "50%", top: "43%", wideTop: "45.85%" },
        { left: "20%", top: "40%", wideTop: "43%" },
        { left: "70%", top: "17.5%", wideTop: "21.625%" },
        { left: "30%", top: "17.5%", wideTop: "21.625%" },
        { left: "50%", top: "13.5%", wideTop: "17.825%" },
    ],
    f433: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "88%", top: "67%", wideTop: "68.65%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "12%", top: "67%", wideTop: "68.65%" },
        { left: "75%", top: "44%", wideTop: "46.8%" },
        { left: "50%", top: "46%", wideTop: "48.7%" },
        { left: "25%", top: "44%", wideTop: "46.8%" },
        { left: "73%", top: "21.5%", wideTop: "25.425%" },
        { left: "50%", top: "17%", wideTop: "21.15%" },
        { left: "27%", top: "21.5%", wideTop: "25.425%" },
    ],
    f433a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "88%", top: "67%", wideTop: "68.65%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "12%", top: "67%", wideTop: "68.65%" },
        { left: "50%", top: "51%", wideTop: "53.45%" },
        { left: "75%", top: "44%", wideTop: "46.8%" },
        { left: "25%", top: "44%", wideTop: "46.8%" },
        { left: "73%", top: "21.5%", wideTop: "25.425%" },
        { left: "50%", top: "17%", wideTop: "21.15%" },
        { left: "27%", top: "21.5%", wideTop: "25.425%" },
    ],
    f433b: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "88%", top: "67%", wideTop: "68.65%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "12%", top: "67%", wideTop: "68.65%" },
        { left: "75%", top: "44%", wideTop: "46.8%" },
        { left: "25%", top: "44%", wideTop: "46.8%" },
        { left: "50%", top: "40%", wideTop: "43%" },
        { left: "73%", top: "21.5%", wideTop: "25.425%" },
        { left: "50%", top: "17%", wideTop: "21.15%" },
        { left: "27%", top: "21.5%", wideTop: "25.425%" },
    ],
    f433c: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "88%", top: "67%", wideTop: "68.65%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "12%", top: "67%", wideTop: "68.65%" },
        { left: "73%", top: "44%", wideTop: "46.8%" },
        { left: "27%", top: "44%", wideTop: "46.8%" },
        { left: "50%", top: "40%", wideTop: "43%" },
        { left: "73%", top: "21.5%", wideTop: "25.425%" },
        { left: "50%", top: "17%", wideTop: "21.15%" },
        { left: "27%", top: "21.5%", wideTop: "25.425%" },
    ],
    f433d: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "88%", top: "67%", wideTop: "68.65%" },
        { left: "68%", top: "70%", wideTop: "71.5%" },
        { left: "32%", top: "70%", wideTop: "71.5%" },
        { left: "12%", top: "67%", wideTop: "68.65%" },
        { left: "50%", top: "48%", wideTop: "50.6%" },
        { left: "71%", top: "43%", wideTop: "45.85%" },
        { left: "29%", top: "43%", wideTop: "45.85%" },
        { left: "50%", top: "25%", wideTop: "28.75%" },
        { left: "73%", top: "20%", wideTop: "24%" },
        { left: "27%", top: "20%", wideTop: "24%" },
    ],
    f4411: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "70%", top: "68%", wideTop: "69.6%" },
        { left: "30%", top: "68%", wideTop: "69.6%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "90%", top: "38%", wideTop: "41.1%" },
        { left: "70%", top: "42%", wideTop: "44.9%" },
        { left: "30%", top: "42%", wideTop: "44.9%" },
        { left: "10%", top: "38%", wideTop: "41.1%" },
        { left: "50%", top: "34.5%", wideTop: "37.775%" },
        { left: "50%", top: "12%", wideTop: "16.4%" },
    ],
    f4411a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "70%", top: "68%", wideTop: "69.6%" },
        { left: "30%", top: "68%", wideTop: "69.6%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "90.5%", top: "38%", wideTop: "41.1%" },
        { left: "71.5%", top: "42%", wideTop: "44.9%" },
        { left: "28.5%", top: "42%", wideTop: "44.9%" },
        { left: "9.5%", top: "38%", wideTop: "41.1%" },
        { left: "50%", top: "36%", wideTop: "39.2%" },
        { left: "50%", top: "14%", wideTop: "18.3%" },
    ],
    f442: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "89%", top: "64%", wideTop: "65.8%" },
        { left: "69%", top: "66%", wideTop: "67.7%" },
        { left: "31%", top: "66%", wideTop: "67.7%" },
        { left: "11%", top: "64%", wideTop: "65.8%" },
        { left: "85%", top: "40%", wideTop: "43%" },
        { left: "65%", top: "42%", wideTop: "44.9%" },
        { left: "35%", top: "42%", wideTop: "44.9%" },
        { left: "15%", top: "40%", wideTop: "43%" },
        { left: "67%", top: "18%", wideTop: "22.1%" },
        { left: "33%", top: "18%", wideTop: "22.1%" },
    ],
    f442a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "89%", top: "64%", wideTop: "65.8%" },
        { left: "69%", top: "66%", wideTop: "67.7%" },
        { left: "31%", top: "66%", wideTop: "67.7%" },
        { left: "11%", top: "64%", wideTop: "65.8%" },
        { left: "65%", top: "42%", wideTop: "44.9%" },
        { left: "35%", top: "42%", wideTop: "44.9%" },
        { left: "85%", top: "40%", wideTop: "43%" },
        { left: "15%", top: "40%", wideTop: "43%" },
        { left: "67%", top: "18%", wideTop: "22.1%" },
        { left: "33%", top: "18%", wideTop: "22.1%" },
    ],
    f451: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "70%", top: "66%", wideTop: "67.7%" },
        { left: "30%", top: "66%", wideTop: "67.7%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "90%", top: "40%", wideTop: "43%" },
        { left: "50%", top: "46%", wideTop: "48.7%" },
        { left: "10%", top: "40%", wideTop: "43%" },
        { left: "70%", top: "34%", wideTop: "37.3%" },
        { left: "30%", top: "34%", wideTop: "37.3%" },
        { left: "50%", top: "16%", wideTop: "20.2%" },
    ],
    f451a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "64%", wideTop: "65.8%" },
        { left: "70%", top: "66%", wideTop: "67.7%" },
        { left: "30%", top: "66%", wideTop: "67.7%" },
        { left: "10%", top: "64%", wideTop: "65.8%" },
        { left: "90%", top: "35%", wideTop: "38.25%" },
        { left: "70%", top: "40%", wideTop: "43%" },
        { left: "50%", top: "43%", wideTop: "45.85%" },
        { left: "30%", top: "40%", wideTop: "43%" },
        { left: "10%", top: "35%", wideTop: "38.25%" },
        { left: "50%", top: "16%", wideTop: "20.2%" },
    ],
    f5212: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "56%", wideTop: "58.2%" },
        { left: "70%", top: "62%", wideTop: "63.9%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "30%", top: "62%", wideTop: "63.9%" },
        { left: "10%", top: "56%", wideTop: "58.2%" },
        { left: "69%", top: "39%", wideTop: "42.05%" },
        { left: "31%", top: "39%", wideTop: "42.05%" },
        { left: "50%", top: "21%", wideTop: "24.95%" },
        { left: "70%", top: "15%", wideTop: "19.25%" },
        { left: "30%", top: "15%", wideTop: "19.25%" },
    ],
    f5221: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "56%", wideTop: "58.2%" },
        { left: "70%", top: "65%", wideTop: "66.75%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "30%", top: "65%", wideTop: "66.75%" },
        { left: "10%", top: "56%", wideTop: "58.2%" },
        { left: "67%", top: "42%", wideTop: "44.9%" },
        { left: "33%", top: "42%", wideTop: "44.9%" },
        { left: "70%", top: "19%", wideTop: "23.05%" },
        { left: "50%", top: "14%", wideTop: "18.3%" },
        { left: "30%", top: "19%", wideTop: "23.05%" },
    ],
    f523: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "59%", wideTop: "61.05%" },
        { left: "70%", top: "64%", wideTop: "65.8%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "30%", top: "64%", wideTop: "65.8%" },
        { left: "10%", top: "59%", wideTop: "61.05%" },
        { left: "67%", top: "42%", wideTop: "44.9%" },
        { left: "33%", top: "42%", wideTop: "44.9%" },
        { left: "73%", top: "21.5%", wideTop: "25.425%" },
        { left: "50%", top: "17%", wideTop: "21.15%" },
        { left: "27%", top: "21.5%", wideTop: "25.425%" },
    ],
    f532: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "59%", wideTop: "61.05%" },
        { left: "70%", top: "64%", wideTop: "65.8%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "30%", top: "64%", wideTop: "65.8%" },
        { left: "10%", top: "59%", wideTop: "61.05%" },
        { left: "50%", top: "37%", wideTop: "40.2%" },
        { left: "78%", top: "35%", wideTop: "38.2%" },
        { left: "22%", top: "35%", wideTop: "38.2%" },
        { left: "63%", top: "13%", wideTop: "17.35%" },
        { left: "37%", top: "13%", wideTop: "17.35%" },
    ],
    f541a: [
        { left: "50%", top: "84%", wideTop: "84.8%" },
        { left: "90%", top: "59%", wideTop: "61.05%" },
        { left: "70%", top: "64%", wideTop: "65.8%" },
        { left: "50%", top: "61%", wideTop: "62.95%" },
        { left: "30%", top: "64%", wideTop: "65.8%" },
        { left: "10%", top: "59%", wideTop: "61.05%" },
        { left: "85%", top: "36%", wideTop: "39.2%" },
        { left: "65%", top: "38%", wideTop: "41.1%" },
        { left: "35%", top: "38%", wideTop: "41.1%" },
        { left: "15%", top: "36%", wideTop: "39.2%" },
        { left: "50%", top: "16%", wideTop: "20.2%" },
    ],
};
const F442 = FORMATION_POSITIONS.f442;
/**
 * A formation's slots. One EA has added since this map was last updated lays
 * out as a 4-4-2 rather than breaking the pitch; add it above.
 */
export const formationSlots = (formation) => (formation && FORMATION_POSITIONS[formation]) || F442;
//# sourceMappingURL=formationPositions.js.map